// Resolves the base URL of the BIKI Azure Functions API.
//
// The Functions app is deployed as a standalone Azure Function App rather than
// as the Static Web App's managed API, so it lives on a different origin in
// Azure. VITE_API_URL is baked in at build time and points at that origin.
//
// When VITE_API_URL is empty the calls stay same-origin, which is what local
// development uses - Vite proxies /api to the Functions host on port 7071.

const configuredOrigin = (import.meta.env.VITE_API_URL ?? '').trim().replace(/\/+$/, '');

/** Origin of the Functions app, or '' when the API is served same-origin. */
export const API_ORIGIN = configuredOrigin;

/** Prefix for every API call, e.g. `https://axp-biki-func.azurewebsites.net/api`. */
export const API_BASE = `${configuredOrigin}/api`;

/**
 * Rebases a URL produced by the backend onto the configured API origin.
 *
 * The image endpoints return relative proxy paths such as `/api/images/x.png`,
 * which resolve against the page origin and 404 once the API is off-origin.
 * Absolute URLs, data URIs and blob URIs are returned untouched.
 */
export function resolveApiUrl(url: string): string {
    if (!url) return url;
    if (/^(?:[a-z][a-z0-9+.-]*:|\/\/)/i.test(url)) return url;
    if (url === '/api' || url.startsWith('/api/')) return `${API_ORIGIN}${url}`;
    return url;
}
